import { DiscoveryApi } from '@backstage/core-plugin-api';
import {
  ContentProps,
  DocumentBackendApi,
  SnackbarStatus,
  MenuItemProps,
} from '../types';

export class BackendClient implements DocumentBackendApi {
  private readonly discoveryApi: DiscoveryApi;
  private documentTable = 'cms';

  constructor(options: { discoveryApi: DiscoveryApi }) {
    this.discoveryApi = options.discoveryApi;
  }
  private async handleResponse(response: Response): Promise<any> {
    if (!response.ok) {
      throw new Error(response.statusText);
    }
    const result = await response.json();
    return {
      type: result.status,
      message: result.message,
      data: result.result,
    };
  }

  async saveDocument({
    title,
    content,
    parent,
    parent_id,
  }: ContentProps): Promise<SnackbarStatus> {
    const url = `${await this.discoveryApi.getBaseUrl(this.documentTable)}`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ title, content, parent, parent_id }),
    });
    return await this.handleResponse(response);
  }

  async updateDocument({
    id,
    title,
    content,
    parent,
    parent_id,
  }: ContentProps): Promise<SnackbarStatus> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.documentTable,
    )}/${id}`;
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ title, content, parent, parent_id }),
    });
    return await this.handleResponse(response);
  }

  async getDocuments(): Promise<SnackbarStatus> {
    const url = `${await this.discoveryApi.getBaseUrl(this.documentTable)}`;
    const response = await fetch(url, {
      method: 'GET',
    });
    return await this.handleResponse(response);
  }

  async getSingleDocuments(title: string): Promise<SnackbarStatus> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.documentTable,
    )}/single`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ title }),
    });
    return await this.handleResponse(response);
  }

  async deleteDocument(id: number): Promise<SnackbarStatus> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.documentTable,
    )}/${id}`;
    const response = await fetch(url, {
      method: 'DELETE',
    });
    return await this.handleResponse(response);
  }

  async getAllParents(): Promise<SnackbarStatus> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.documentTable,
    )}/allparent`;
    const response = await fetch(url, {
      method: 'GET',
    });
    return await this.handleResponse(response);
  }

  async saveDocumentSequence(item: MenuItemProps[]): Promise<SnackbarStatus> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.documentTable,
    )}/allmenu`;
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(item),
    });
    return await this.handleResponse(response);
  }

  async searchDocument(content: string): Promise<SnackbarStatus> {
    const url = `${await this.discoveryApi.getBaseUrl(
      this.documentTable,
    )}/search/?q=${content}`;
    const response = await fetch(url, {
      method: 'GET',
    });
    return await this.handleResponse(response);
  }
}
